<!--  -->
<template>
  <el-container>
    <el-header height="130px">
      <pubhead></pubhead>
    </el-header>
    <el-main>
      <div id="userMenu_div">
        <userMenu></userMenu>
      </div>
      <div id="userCenter_div">
        <router-view />
      </div>
    </el-main>
    <el-footer height="30px">
      <pubfooter></pubfooter>
    </el-footer>
  </el-container>
</template>

<script>
import pubhead from '@/components/public/head_searchbox'
import userMenu from '@/components/userCenter/menu'
import pubfooter from '@/components/public/footer'
export default {
  name: 'welcome',
  components: {
    pubhead: pubhead,
    userMenu: userMenu,
    pubfooter: pubfooter
  },
  data () {
    return {}
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
#userMenu_div {
  width: 220px;
  float: left;
}
#userCenter_div {
  width: -webkit-calc(100% - 220px);
  width: -moz-calc(100% - 220px);
  width: calc(100% - 220px);
  float: right;
  height: -webkit-calc(100vh - 170px);
  height: -moz-calc(100vh - 170px);
  height: calc(100vh - 170px);
}
.el-header {
  color: #333;
  text-align: center;
  padding-top: 10px;
}
.el-footer {
  color: #333;
  text-align: center;
}

.el-aside {
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  color: #333;
  text-align: center;
  overflow: hidden;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>
